/**
 * Created by yibrahim on 17/07/2017.
 */
import { Component } from '@angular/core';

@Component({
  template: '<h2>Page not found</h2>'
})
export class PageNotFoundComponent {}



// WEBPACK FOOTER //
// ./src/app/page-not-found.component.ts